import { hardcodedSettingsConstants } from './constants';

export const hardcodedSettingsReducers = function (state = {
    superAdmins: {}
}, action) {
    switch (action.type) {
    case hardcodedSettingsConstants.GET_SUPER_ADMINS_REQUEST:
        return {
            ...state,
            send: true,
            sendSuperAdmins: true
        };
    case hardcodedSettingsConstants.GET_SUPER_ADMINS_SUCCESS:
        return {
            ...state,
            superAdmins: action.payload,
            send: false,
            sendSuperAdmins: false
        };
    case hardcodedSettingsConstants.GET_SUPER_ADMINS_ERROR:
        return {
            ...state,
            errors: action.error,
            send: false,
            sendSuperAdmins: false
        };
    default:
        return state;
    }
};
